import type { EligibleProduct, IntegratedSalesSteps } from "../../../types";

/**
 * The enroll-vs-track decision for a product, keyed purely off the product's
 * flags — never off whether a `salesOfferChecklist` exists.
 *
 * - primary + Asurion-billed  → CollectCustomerInfoStep (full live enrollment)
 * - primary + not Asurion-billed → SendLinkStep (customer completes via smart link)
 * - not primary (attach/secondary) → InlineSaleTrackerStep (track externally)
 *
 * This is the single source of truth used both by {@link SalesFooter} (to pick
 * the next step after the guided offer step) and by the integrated flow to pick
 * the *entry* step when a product has no checklist and therefore skips the
 * checklist-dependent `SuggestedOfferStep`. Keeping enroll-vs-track on the flags
 * (not on checklist presence) lets a no-checklist product still enroll live.
 */
export const getEnrollmentEntryStep = (product?: EligibleProduct): IntegratedSalesSteps => {
    if (product?.isPrimaryProduct) {
        return product?.isProductAsurionBilled ? "CollectCustomerInfoStep" : "SendLinkStep";
    } else {
        return "InlineSaleTrackerStep";
    }
};
